import { HTMLChakraProps, chakra } from "@chakra-ui/react";
import { motion, HTMLMotionProps } from "framer-motion";
import Merge from "../IMerge";

type MotionTextProps = Merge<HTMLChakraProps<"p">, HTMLMotionProps<"p">>;
const MotionText: React.FC<MotionTextProps> = motion(chakra.p);

export default MotionText;
